<template>
  <div
    id="cards-cta"
    class="cta-container container relative z-[3] mx-auto flex max-w-screen-xl flex-col pb-16 md:flex-row lg:pb-24"
  >
    <template v-for="(card, index) in cards" :key="index">
      <div
        class="cta-card border border-[color:var(--color-border)]"
        :class="{ 'cta-card-same-start cta-cards-same-size': sameHeight }"
      >
        <a :aria-label="card.title" :href="card.buttonLink">
          <VcImage v-if="card.image" :src="card.image" class="mb-8 w-full object-contain" lazy />
        </a>
        <VcTypography tag="h3">{{ card.title }}</VcTypography>
        <p>{{ card.text }}</p>
        <VcButton
          v-if="card.buttonLink && card.buttonLabel"
          :to="card.buttonLink"
          color="secondary"
          variant="no-background"
          size="lg"
          class="mt-6 w-fit p-0"
        >
          {{ card.buttonLabel }}
        </VcButton>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
type CardsType = {
  image?: string;
  title?: string;
  text?: string;
  buttonLabel?: string;
  buttonLink?: string;
};

interface IProps {
  id: string;
  background?: string;
  textColor?: string;
  bottomMargin?: string;
  verticalPadding?: string;
  title?: string;
  cards?: Array<CardsType>;
  sameHeight?: boolean | null;
}

defineProps<IProps>();
</script>

<style lang="scss" scoped>
.cta-container-negative {
  margin-top: -150px;
}

.cta-container {
  column-gap: 50px;
}

.cta-card {
  background: #fff;
  padding: 30px;
  border-radius: 8px;
  height: fit-content;
  margin-bottom: 20px;

  &.cta-cards-same-size {
    height: auto;
  }
}

@media (min-width: 1024px) {
  .cta-card {
    width: 25%;
    margin-bottom: 0;

    &:nth-child(2) {
      width: 50%;
      margin-top: 100px;
    }

    &.cta-cards-same-size {
      width: 33%;

      &:nth-child(2) {
        width: 33%;
      }
    }
  }

  .cta-card-same-start.cta-card:nth-child(2) {
    margin-top: 0;
  }

  .cta-container-negative {
    margin-top: -25vh;
  }
}

/* When the preceeding item is a banner-video we make some extra space for text on smaller viewports */
@media (max-width: 768px) {
  .banner-video + .cta-container {
    margin-top: -40px;
  }
}
@media (max-width: 500px) {
  .banner-video + .cta-container {
    margin-top: 15px;
  }
}
</style>
